import React from 'react';
import { getTableColumns } from 'helpers';
import atoms from 'ctsutheme/components/atoms';
import { BoolToString } from 'components';
import { FasPencilAlt } from 'assets/icons';
import { CanUserEditOPENRelations } from 'appconstants/Permission';
import { RenderElement } from 'components/RenderHelpers';
import { TE } from 'appconstants';

const {
  IconButton,
  Tooltip
} = atoms;

const EmbeddedColumns1 = [
  ['relatedProtocolNumber', 'string', 'Study Number', 'center', true],
  ['title', 'string', 'Study Title', 'left', true],
  ['aliasForGroup', 'string', 'Group Protocol Number', 'left', true],
  ['step', 'string', 'Step', 'center', true]
];

const EmbeddedColumns2 = [
  ['delayedEnrollDays', 'string', '# Days', 'center', true],
  ['startDate', 'string', 'Start Date', 'center', true],
  ['endDate', 'string', 'End Date', 'center', true],
  ['comments', 'string', 'Comments', 'left', true],
  ['createdBy', 'string', 'Created by', 'center', true]
];

const EmbededStudiesColumns = [
  ...getTableColumns(EmbeddedColumns1),
  {
    name: 'relationType',
    type: 'string',
    label: 'Study Type',
    filterable: true,
    renderCell: data => ('EMBEDDED')
  },
  {
    name: 'isMandatory',
    type: 'string',
    label: 'Required?',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />),
    exportAsYesNo: true
  },
  ...getTableColumns(EmbeddedColumns2),
  {
    name: 'prnId',
    type: 'string',
    label: 'Action(s)',
    filterable: false,
    align: 'center',
    renderCell: (data, rowEvents) => (
      <RenderElement access={CanUserEditOPENRelations()}>
        <Tooltip
          tooltipplacementbottom="true"
          title="Edit Embedded Study"
          aria-label="Edit Embedded Study"
        >
          <IconButton
            key="UserPrtEmbed"
            color="primary"
            data-id={`${TE.ID}UserPrtEmbed${TE.BTN}`}
            onClick={() => rowEvents[0](data)}
          >
            <FasPencilAlt />
          </IconButton>
        </Tooltip>
      </RenderElement>
    )
  }];


export default EmbededStudiesColumns;
